<template>
  <div class="node-history">
    <div
      class="paragraph clearfix paragraph--type--paragraph-view paragraph--view-mode--default"
      data-equalizer="nmlqnc-equalizer"
      data-equalize-by-row="true"
      data-equalize-on="small"
      data-equalize-on-stack="true"
      data-resize="nmlqnc-equalizer"
      data-mutate="nmlqnc-equalizer"
      data-events="resize"
    >
      <div
        class="field field--name-field-paragraph-block field--type-block-field field--label-hidden field__items"
      >
        <div class="field__item">
          <div
            data-block-plugin-id="views_block:milestone_timelines-milestones_page"
            class="block__wrapper"
          >
            <div class="views-element-container">
              <div
                class="row collapse magellan-container js-view-dom-id-ae52a078cba793b9f7be4e73f0fdcef2faba18fbe38f9dff41bc987e89538b0c"
              >
                <!-- <header
                class="small-12 medium-2 large-1 columns sticky-container"
                data-sticky-container
                style="height: 495.875px;"
              >
                <nav
                  class="sticky is-anchored is-at-top"
                  data-sticky="9pp5ur-sticky"
                  data-anchor="chaptered-content"
                  data-sticky-on="medium"
                  data-check-every="5"
                  data-margin-top="7"
                  data-resize="90y43b-sticky"
                  data-mutate="90y43b-sticky"
                  data-events="mutate"
                  style="max-width: 116.828px; margin-top: 0px; top: 0px; bottom: auto;"
                >
                  <ul class="vertical menu magellan" data-magellan data-bar-offset="200">
                    <li>
                      <a href="#c2000s">2000s</a>
                    </li>
                    <li>
                      <a href="#c1900s">1900s</a>
                    </li>
                    <li>
                      <a href="#c1800s">1800s</a>
                    </li>
                    <li>
                      <a href="#c1700s">1700s</a>
                    </li>
                    <li>
                      <a href="#c1600s">1600s</a>
                    </li>
                  </ul>
                </nav>
                </header>-->

                <div
                  class="small-12 medium-10 large-11 columns milestone-timeline"
                  data-sticky-container
                  id="chaptered-content"
                  data-mutate="90y43b-sticky"
                >
                  <span id="c2000s" data-magellan-target="c2000s"></span>
                  <div class="milestone-section" v-for="(item,index) in list" :key="index">
                    <h3>{{item.title}}</h3>

                    <ul>
                      <li class="no-bullet">
                        <span class="milestone-bullet"></span>
                        <div class="milestone-image">
                          <article class="view-mode-tile-small media media-image">
                            <div
                              data-blazy
                              class="blazy blazy--field blazy--image blazy--image--milestones-page blazy--view blazy--view--milestone-timelines blazy--view--milestone-timelines--milestones-page field field--name-image field--type-image field--label-hidden field__item blazy--on"
                            >
                              <div
                                class="media media--bundle--image media--blazy media--responsive media--image"
                              >
                                <img
                                  class="media__image media__element b-lazy b-responsive b-loaded"
                                  sizes="(min-width:22.5em) 33.333vw, (min-width:120em) 25vw, 100vw"
                                  :src="item.cover"
                                  alt
                                  typeof="foaf:Image"
                                />
                              </div>
                            </div>
                          </article>
                        </div>
                        <p>{{item.brief}}</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["list"],
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang='less' scoped>
@media print, screen and (max-width: 40em) {
  .no-bullet {
    p {
      padding: 0 1rem;
    }
  }
  .node-history{
    margin-top: 2rem;
  }
  .milestone-section{
    padding-bottom: 0!important;
  }
}
</style>